export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1000px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
            <div className="flex-1 w-full lg:text-left text-center">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">移动观影</h2>
              <p className="text-sm text-foreground-600 mt-1">随时随地 · 畅享高清影视</p>
              <p className="text-sm text-foreground-600 mt-5 leading-relaxed max-w-[480px] mx-auto lg:mx-0">
                人人影院移动端适配完美，无需下载APP，手机浏览器直接访问即可享受与桌面端一致的高清观影体验。
                支持手势控制、投屏播放、离线缓存等功能，通勤路上、午休时间随时随地追剧。
              </p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 mt-6">
                <div className="flex items-center gap-2 bg-background-200 rounded-lg px-4 py-2.5">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-smartphone-line text-primary-500"></i>
                  </div>
                  <span className="text-sm text-foreground-700 whitespace-nowrap">手机端适配</span>
                </div>
                <div className="flex items-center gap-2 bg-background-200 rounded-lg px-4 py-2.5">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-tablet-line text-primary-500"></i>
                  </div>
                  <span className="text-sm text-foreground-700 whitespace-nowrap">平板优化</span>
                </div>
                <div className="flex items-center gap-2 bg-background-200 rounded-lg px-4 py-2.5">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-cast-line text-primary-500"></i>
                  </div>
                  <span className="text-sm text-foreground-700 whitespace-nowrap">投屏播放</span>
                </div>
              </div>

              <div className="flex items-center justify-center lg:justify-start gap-3 mt-6">
                <a
                  href="#app"
                  className="px-5 py-2.5 rounded-lg text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-android-line mr-1.5"></i>Android 版
                </a>
                <a
                  href="#app"
                  className="px-5 py-2.5 rounded-lg text-sm font-medium text-foreground-700 border border-background-300 hover:text-foreground-950 hover:border-foreground-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-apple-line mr-1.5"></i>iOS 版
                </a>
              </div>
            </div>

            <div className="flex-1 w-full max-w-[360px] lg:max-w-[400px]">
              <div className="relative">
                <div className="absolute -inset-6 rounded-3xl bg-primary-500/5 blur-2xl"></div>
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20a%20movie%20streaming%20app%20interface%20with%20dark%20theme%2C%20film%20posters%20grid%20layout%2C%20warm%20golden%20accent%20colors%2C%20clean%20minimal%20UI%20design%2C%20cinematic%20aesthetic%2C%20professional%20app%20screen%20mockup%2C%20floating%20phone%20perspective&width=500&height=400&seq=app-mockup&orientation=landscape"
                  alt="人人影院移动端界面预览"
                  className="w-full object-contain relative"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}